import React from 'react';

const ErrorMessage = (props) => (
    <div className="error-message-container">
        <h1>{props.message}</h1>
    </div>
);

export default ErrorMessage;


// WEBPACK FOOTER //
// ./src/Components/ErrorMessage.js